import { render } from "./MovimentiIgnotiList.vue?vue&type=template&id=5bafab8a&scoped=true"
import script from "./MovimentiIgnotiList.vue?vue&type=script&lang=js"
export * from "./MovimentiIgnotiList.vue?vue&type=script&lang=js"

import "./MovimentiIgnotiList.vue?vue&type=style&index=0&id=5bafab8a&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bafab8a"]])

export default __exports__